import React from 'react';
import { useEyeMove } from "../hooks/useEyeMove.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Illustration500() {
  const leftEye = {
    x: 158,
    y: 57
  };
  const rightEye = {
    x: 167,
    y: 57
  };
  const {
    svg,
    translatedLeftEye,
    translatedRightEye
  } = useEyeMove({
    leftEye,
    rightEye
  });
  return /*#__PURE__*/_jsx("svg", {
    ref: svg,
    width: "365",
    height: "130",
    viewBox: "0 0 365 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M201.139 32.1528L193.642 11.6226C186.356 8.42104 178.483 6.77208 170.524 6.7807C141.039 6.7807 114.407 28.9673 114.407 64.6249C114.407 88.2947 126.15 106.019 142.666 115.269L148.444 107.666H168.042V122.412C168.868 122.447 169.695 122.47 170.526 122.47C200.014 122.47 226.645 100.283 226.645 64.6262C226.818 53.1614 223.69 41.8888 217.634 32.1528H201.139Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802"
      }), /*#__PURE__*/_jsx("path", {
        d: "M51.253 44.1963C44.2942 44.0636 37.4357 45.8695 31.4446 49.4121L33.1382 23.3343H76.4196L68.7129 2.47116H15.354L11.1187 72.8813L26.3613 74.6145C26.3613 74.6145 32.9649 63.3139 46.681 63.3139C61.073 63.3139 69.5411 72.0073 69.5411 85.0449C69.5411 97.2333 62.1389 105.621 49.4158 106.662L47.2727 126.765C47.3569 126.765 47.4399 126.765 47.5204 126.765C73.7665 126.765 92.3938 107.641 92.3938 85.0437C92.4307 79.6444 91.3896 74.2921 89.3315 69.3003C87.2734 64.3086 84.2397 59.7778 80.4081 55.9736C76.5765 52.1693 72.0242 49.1681 67.0178 47.1458C62.0115 45.1235 56.6519 44.1207 51.253 44.1963Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802"
      }), /*#__PURE__*/_jsx("path", {
        d: "M40.6345 106.757C32.0548 105.081 24.3191 100.488 18.74 93.7581L4.34796 108.148C4.34796 108.148 15.744 122.873 38.5174 126.132L40.6345 106.757Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802"
      }), /*#__PURE__*/_jsx("path", {
        d: "M215.872 4.44327L212.01 17.6654L224.49 25.923L215.872 4.44327Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M80.1856 2.89203L91.8713 0.62027L92.2848 17.814L80.1856 2.89203Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.619019 83.7512L8.32573 85.316L4.71193 93.5687L0.619019 83.7512Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M339.157 6.51575L346.864 8.08062L343.25 16.3333L339.157 6.51575Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M250.492 107.175L269.395 109.227L262.71 122.474C251.751 116.992 251.572 110.947 250.492 107.175Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M235.626 119.789C237.106 119.789 238.306 118.589 238.306 117.108C238.306 115.628 237.106 114.428 235.626 114.428C234.146 114.428 232.945 115.628 232.945 117.108C232.945 118.589 234.146 119.789 235.626 119.789Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M108.442 15.1831C109.923 15.1831 111.123 13.9831 111.123 12.5028C111.123 11.0225 109.923 9.82248 108.442 9.82248C106.962 9.82248 105.762 11.0225 105.762 12.5028C105.762 13.9831 106.962 15.1831 108.442 15.1831Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M146.312 119.789L140.048 126.132C142.543 127.994 145.515 129.11 148.619 129.351C151.687 129.501 154.714 128.592 157.192 126.776L154.888 119.79L146.312 119.789Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M348.792 59.3831H363.401C362.633 46.7789 357.71 34.7845 349.401 25.2755H335.635L327.711 10.4267C320.512 7.73886 312.849 6.51535 305.17 6.82785C297.492 7.14036 289.953 8.98259 282.996 12.2466L271.878 26.4727L261.08 31.0732C254.559 41.0335 251.177 52.7206 251.37 64.6237C251.235 75.103 253.827 85.4373 258.892 94.6123L287.386 101.967L281.939 116.491C289.876 120.437 298.623 122.483 307.487 122.468C333.588 122.468 357.438 105.072 362.573 76.3465H346.28L348.792 59.3831Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.23802"
      }), /*#__PURE__*/_jsx("path", {
        d: "M285.71 101.804H300.42L309.557 87.2188",
        fill: "#CCD7CB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M285.71 101.804H300.42L309.557 87.2188",
        stroke: "#272727",
        strokeWidth: "1.23802"
      }), /*#__PURE__*/_jsx("path", {
        d: "M157.446 59.3212C158.718 59.3212 159.75 58.2897 159.75 57.0172C159.75 55.7448 158.718 54.7133 157.446 54.7133C156.173 54.7133 155.142 55.7448 155.142 57.0172C155.142 58.2897 156.173 59.3212 157.446 59.3212Z",
        fill: "#272727",
        transform: `translate(${translatedLeftEye?.x} ${translatedLeftEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M183.853 59.2915C185.125 59.2915 186.157 58.26 186.157 56.9875C186.157 55.7151 185.125 54.6836 183.853 54.6836C182.58 54.6836 181.549 55.7151 181.549 56.9875C181.549 58.26 182.58 59.2915 183.853 59.2915Z",
        fill: "#272727",
        transform: `translate(${translatedRightEye?.x} ${translatedRightEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M165.373 74.5563C165.806 73.5304 166.529 72.653 167.453 72.0315C168.377 71.4099 169.462 71.0711 170.576 71.0566C171.689 71.042 172.783 71.3523 173.723 71.9494C174.663 72.5466 175.409 73.4047 175.869 74.4189",
        stroke: "#272727",
        strokeWidth: "1.23802",
        strokeLinecap: "round"
      })]
    })
  });
}